import { format } from "date-fns";
import { es } from "date-fns/locale";

/**
 * Formatea una fecha de forma segura para pintarla en una fila de listado.
 *
 * A diferencia de llamar a `format(new Date(value), pattern)` directamente,
 * nunca lanza: si `value` es `null`/`undefined` o no es una fecha válida
 * (p. ej. un registro importado desde un CSV legado con un dato corrupto en
 * `createdAt`), devuelve `fallback` en vez de reventar el render de toda la
 * fila con un `RangeError: Invalid time value`.
 */
export function safeFormatDate(
  value: string | number | Date | null | undefined,
  pattern: string,
  fallback = "—",
): string {
  if (value === null || value === undefined || value === "") return fallback;
  try {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return fallback;
    return format(date, pattern, { locale: es });
  } catch {
    return fallback;
  }
}
